export default __webpack_public_path__ + "static/media/active-grupo-economico.7c7db2f2.svg";